<div style="display:flex;height: 100%;align-items: center;">
    <!-- <span style="padding-right: 4px;">{{imageUrl}}</span> -->
    <div style="display: inline-block;">
        <svg style="margin-right: 4px;" class="icon-14">
            <use [attr.href]="imageUrl"></use>
        </svg>
    </div>
    <div style="display: inline-block;"><span>{{state}}</span></div>
</div>